import { Button } from '@material-ui/core'
import React, { ReactElement } from 'react'
import { LicenseManagement } from '../../../../../i18n'
import CLanguageHandler from '../../../../NonReact/Languages/LanguageHandler'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'
import { IsStringEmpty, isVarNotEmpty } from '../../../../NonReact/utils/GlobalFunctions'
import { UseFormMethods } from '../../../../Vendor/react-hook-form/dist/index.ie11'
import { TelSysForm } from '../../../TelSysConfiguration/Types/Types'
import Icon, { IconName } from '../Icon'
import { TableRow } from '../Table/Table'
import { AlignPositions } from '../Table/types'
import { ValidationErrors } from '../ValidationErrors/ValidationErrors'
import { Rules } from '../../Rules/Rules'
import { CMEFormHookData } from '../../../CMEAddModify/Types'
import { OutlinedTextInput } from '../../../../ReactRouting/Components/Atoms/Inputs/OutlinedTextInput'

/**
 * Create row entry.
 *
 * @param name - The name for React Hook Form.
 * @param language - inatance of language resource
 * @param rowTitles - Title of the row (displayed in first column)
 * @param limit - telsys cap
 * @param rowClassName - Class name for the row.
 * @param methods - Form methods.
 * @param disabled - Whether the input is disabled.
 */
const createRow = (
    { setValue, watch, trigger }: UseFormMethods<CMEFormHookData> | UseFormMethods<TelSysForm>,
    language: CLanguageHandler,
    name: string,
    rowClassName: string,
    limit: Nullable<number>,
    disabled?: boolean,
    ...rowTitles: string[]
): TableRow => ({
    rowClassName,
    columns: [
        {
            content: (
                <div className='lm-row-title'>
                    {rowTitles.map(
                        (rowTitle: string, index: number): ReactElement => (
                            <b key={`rowTitle-${index}`}>{rowTitle}</b>
                        )
                    )}
                </div>
            ),
            props: {
                component: 'th',
                align: AlignPositions.LEFT
            }
        },
        {
            content: (
                <div className='lm-input-container'>
                    <ValidationErrors name={name}>
                        <OutlinedTextInput
                            inputName={name}
                            disabled={disabled}
                            onChange={(newValue: string): void => {
                                setValue(name, newValue)
                            }}
                            placeholder='Unlimited'
                            adornmentEnd={
                                disabled ? (
                                    <></>
                                ) : (
                                    <Button
                                        className='lm-action-button'
                                        disabled={IsStringEmpty(watch(name))}
                                        onClick={() => {
                                            setValue(name, EMPTY_STRING)
                                            trigger(name)
                                        }}
                                    >
                                        <Icon iconName={IconName.X} />
                                    </Button>
                                )
                            }
                            rules={{
                                validate: {
                                    isPositiveNumber: Rules.isPositiveNumber(language),
                                    isInteger: Rules.isInteger(language),
                                    isUnderLimit: Rules.isUnderLimit(
                                        language,
                                        LicenseManagement.LicenseManagement_Validation_Limit,
                                        limit ?? Number.MAX_SAFE_INTEGER,
                                        isVarNotEmpty(limit)
                                    )
                                }
                            }}
                        />
                    </ValidationErrors>
                </div>
            ),
            props: { align: AlignPositions.LEFT }
        }
    ]
})

export default createRow
